import { LiveData, Service } from '@toeverything/infra';

/** A new message another part of the app asks the mail view to start. */
export interface MailComposeHandoff {
  /** Files the message starts with, attached like files picked in the composer. */
  files: File[];
}

/**
 * Carries a requested new message into the mail view. The requester (the PDF
 * reader's "send by mail") hands over the files and opens the mail view; the
 * view takes the request once and starts the message with them. Nothing is
 * uploaded or stored here: the composer uploads the files when it sends.
 */
export class MailComposeHandoffService extends Service {
  readonly pending$ = new LiveData<MailComposeHandoff | null>(null);

  requestNewMessage(handoff: MailComposeHandoff) {
    this.pending$.next({ files: [...handoff.files] });
  }

  /** The pending request, handed out once. */
  take(): MailComposeHandoff | null {
    const pending = this.pending$.value;
    if (pending) this.pending$.next(null);
    return pending;
  }
}
